import { BaseLayoutFactory } from '../../../components/base-layout-factory';
import { PoliticalPartyCreateEditProvider } from './context/political-party-create-edit-context';
import { PoliticalPartyCreateEditComponent } from './political-party-create-edit-component';

export function PoliticalPartyCreateEditFactory() {
    return (
        <BaseLayoutFactory>
            <PoliticalPartyCreateEditProvider>
                <PoliticalPartyCreateEditComponent />
            </PoliticalPartyCreateEditProvider>
        </BaseLayoutFactory>
    );
}
